import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

enum PolicyOptions {
  Privacy = 'privacy',
  Cookies = 'cookies'
}

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss']
})
export class PrivacyPolicyModalComponent {
  PolicyOptions = PolicyOptions;
  selectedOption: PolicyOptions = PolicyOptions.Privacy;

  constructor(public dialogRef: MatDialogRef<PrivacyPolicyModalComponent>) {}

  selectOption(option: PolicyOptions): void {
    this.selectedOption = option;
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
